
const consts = {
    VIEWREPORTURL:"http://192.168.0.123:7777"
}
export default consts
